module.exports = __webpack_public_path__ + "static/img/comfirmen.18773db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/comfirmen.png
// module id = B4Ad
// module chunks = 1